// src/constants/listingOptions.js

export const ROOM_TYPE_OPTIONS = [
  "Single Room",
  "1BHK",
  "2BHK",
  "3BHK",
  "Studio Apartment",
  "Serviced Apartment",
  "Shared Room (2 Sharing)",
  "Shared Room (3 Sharing)",
  "Shared Room (4 Sharing)",
  "PG Room",
  "Dormitory Room",
  "House",
  "Hostel",
  "Office",
  "Commercial Space"
];

export const NEPAL_PROVINCES = [
  "Koshi",
  "Madhesh",
  "Bagmati",
  "Gandaki",
  "Lumbini",
  "Karnali",
  "Sudurpashchim",
];

export const FACILITY_OPTIONS = [
  "Wi-Fi",
  "Water Supply",
  "Electricity",
  "Air Conditioning",
  "Heating",
  "Semi-Furnished",
  "Fully-Furnished",
  "Luxury",
  "Premium",
  "Parking",
  "Laundry",
  "Washing Machine",
  "Kitchen Access",
  "Private Bathroom",
  "Attached Bathroom",
  "Desk",
  "Closet",
  "Balcony",
  "Pet Friendly",
  "Smoking Allowed",
  "Smoking Prohibited",
  "Gym Access",
  "CCTV",
  "Security Guard",
  "Lift",
];

export const CITIES = [
  "Kathmandu",
  "Pokhara",
  "Lalitpur",
  "Bharatpur",
  "Biratnagar",
  "Birgunj",
  "Dharan",
  "Butwal",
  "Hetauda",
  "Janakpur",
  "Nepalgunj",
  "Dhangadhi",
  "Itahari",
  "Bhaktapur",
  "Tulsipur",
  "Birtamod",
  "Mechinagar",
  "Damak",
  "Ghorahi",
  "Siddharthanagar",
  "Kirtipur",
  "Lahan",
  "Banepa",
  "Dhankuta",
];


export const LEASE_OPTIONS = [
  "Flexible",
  "3 Months",
  "6 Months",
  "12 Months",
  "Long Term",
];
